<template>
  <div class="question-edit-wrap vh-q-sdk">
    <div class="edit-content">
      <div class="btn-box">
        <div class="add-que">
          <!-- <vh-scrollbar> -->
          <div class="content">
            <p class="title">基本信息</p>
            <div class="funActions">
              <div class="button-list">
                <div class="btn-li">
                  <a
                    href="javascript:void(0)"
                    @click="
                      isName || q.addQuestion(q.getName()) || clickSelect()
                    "
                    :class="{ disabled: isName }"
                  >
                    <i class="iconfont-v3 saasicon_name"></i>
                    姓名</a
                  >
                  <a
                    href="javascript:void(0)"
                    @click="isSex || q.addQuestion(q.getSex()) || clickSelect()"
                    :class="{ disabled: isSex }"
                    ><i class="iconfont-v3 saasicon_gender"></i> 性别</a
                  >
                  <a
                    href="javascript:void(0)"
                    @click="isPhone || q.addQuestion(q.getPhone())"
                    :class="{ disabled: isPhone }"
                  >
                    <i class="iconfont-v3 saasicon_phone"></i>手机
                  </a>
                  <a
                    href="javascript:void(0)"
                    @click="
                      isEmail || q.addQuestion(q.getEmail()) || clickSelect()
                    "
                    :class="{ disabled: isEmail }"
                    ><i class="iconfont-v3 saasicon_mail"></i> 邮箱</a
                  >
                  <!--                                            <a href="javascript:void(0)" @click="isAreade||q.addQuestion(q.getAreade())" :class="{disabled: isAreade}">-->
                  <!--                                                地域-->
                  <!--                                            </a>-->
                  <a
                    href="javascript:void(0)"
                    @click="
                      isArea || q.addQuestion(q.getCity()) || clickSelect()
                    "
                    :class="{ disabled: isArea }"
                    ><i class="iconfont-v3 saasicon_regional"></i> 地域</a
                  >
                  <a
                    href="javascript:void(0)"
                    @click="
                      isCompany ||
                        q.addQuestion(q.getCompany()) ||
                        clickSelect()
                    "
                    :class="{ disabled: isCompany }"
                    ><i class="iconfont-v3 saasicon_company"></i> 公司</a
                  >
                  <a
                    href="javascript:void(0)"
                    @click="
                      isPosition ||
                        q.addQuestion(q.getPosition()) ||
                        clickSelect()
                    "
                    :class="{ disabled: isPosition }"
                    ><i class="iconfont-v3 saasicon_position"></i> 职务</a
                  >
                  <a
                    href="javascript:void(0)"
                    @click="
                      isBirthday ||
                        q.addQuestion(q.getBirthday()) ||
                        clickSelect()
                    "
                    :class="{ disabled: isBirthday }"
                    ><i class="iconfont-v3 saasicon_shengri"></i> 生日</a
                  >
                  <a
                    href="javascript:void(0)"
                    @click="
                      isIndustry ||
                        q.addQuestion(q.getIndustry()) ||
                        clickSelect()
                    "
                    :class="{ disabled: isIndustry }"
                    ><i class="iconfont-v3 saasicon_hangye"></i> 行业</a
                  >
                  <a
                    href="javascript:void(0)"
                    @click="
                      isEducation ||
                        q.addQuestion(q.getEducation()) ||
                        clickSelect()
                    "
                    :class="{ disabled: isEducation }"
                    ><i class="iconfont-v3 saasicon_jiaoyu"></i> 教育水平</a
                  >
                </div>
              </div>
            </div>
            <p class="title">表单题型</p>
            <!-- 功能区 start -->
            <div class="funActions">
              <div class="button-list">
                <div class="btn-li">
                  <a
                    href="javascript:void(0)"
                    @click="
                      isRadio || q.addQuestion(q.getRadio()) || clickSelect()
                    "
                    :class="{ disabled: isRadio }"
                    ><i class="iconfont-v3 saasicon_radio"></i> 单选题</a
                  >

                  <a
                    href="javascript:void(0)"
                    @click="
                      isCheckbox ||
                        q.addQuestion(q.getCheckbox()) ||
                        clickSelect()
                    "
                    :class="{ disabled: isCheckbox }"
                    ><i class="iconfont-v3 saasicon_multi-select"></i> 多选题</a
                  >
                  <a
                    href="javascript:void(0)"
                    @click="isQue || q.addQuestion(q.getQA()) || clickSelect()"
                    :class="{ disabled: isQue }"
                    ><i class="iconfont-v3 saasicon_question"></i> 问答题</a
                  >
                  <a
                    href="javascript:void(0)"
                    @click="
                      isSelect || q.addQuestion(q.getSelect()) || clickSelect()
                    "
                    :class="{ disabled: isSelect }"
                    ><i class="iconfont-v3 saasicon_drop-down"></i> 下拉题</a
                  >
                  <!--                                            <a href="javascript:void(0)" @click="isArea||q.addQuestion(q.getCity())" :class="{disabled: isArea}">-->
                  <!--                                                城市题-->
                  <!--                                            </a>-->
                  <a
                    href="javascript:void(0)"
                    @click="
                      isRemark || q.addQuestion(q.getRemark()) || clickSelect()
                    "
                    :class="{ disabled: isRemark }"
                    ><i class="iconfont-v3 saasicon_list"></i> 小节</a
                  >
                </div>
              </div>
            </div>
            <!-- 功能区 end -->
          </div>
          <!-- </vh-scrollbar> -->
          <!-- </message-box> -->
        </div>
      </div>
      <div class="edit-content-main vhall-question-content">
        <div class="base-info vhall-question-content-baseInfo" v-if="q">
          <div class="q-title vhall-question-content-baseInfo__title">
            <div class="show-des">标题（选填）</div>
            <div class="edit question_title">
              <com-input
                placeholder="标题"
                :class="{ error: titleError }"
                v-model="q.title"
                :max-length="50"
              />
            </div>
          </div>
          <div class="q-des vhall-question-content-desc">
            <div class="show-des">简介（选填）</div>
            <div
              class="edit"
              :class="{ editing: descriptionCheck.value.ext.edit }"
              @click.stop
            >
              <com-input
                placeholder="请填写简介"
                type="textarea"
                v-model="q.description"
                :max-length="500"
              ></com-input>
            </div>
          </div>
          <div class="vhall-question-content-img">
            <div class="show-des banner">
              头图
              <vh-switch
                v-model="enable_banner"
                size="mini"
                class="banner-switch"
              >
              </vh-switch>
              设置表单页顶部图样式
            </div>
            <vh-upload
              class="avatar-uploader"
              :headers="headersVo"
              :data="params"
              name="resfile"
              :show-file-list="false"
              :action="`${saasBaseUrl || ''}/v3/commons/upload/index`"
              accept="image/x-ms-bmp,image/x-png,image/gif,image/jpeg,image/bmp"
              :on-progress="uploadProcess"
              :on-error="uploadError"
              :on-preview="uploadPreview"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <div class="box">
                <div>
                  <div class="img-logo">
                    <img :src="domainUrl || defaultImg" class="avatar" alt="" />
                  </div>
                  <div class="mask">
                    <span>
                      <i class="vh-icon-refresh-left"></i>
                      <br />
                      更换
                    </span>
                    <span @click.stop.prevent="deletes" v-if="domainUrl">
                      <i class="iconfont-v3 saasicon_shanchu"></i>
                      <br />
                      删除
                    </span>
                  </div>
                </div>
              </div>
            </vh-upload>
            <div class="tips">
              建议尺寸：750x120px，小于2MB（支持格式jpg、png、gif、bmp）
            </div>
          </div>
          <div
            class="vhall-question-playback playback-set"
            v-if="isPlayBackSet !== false"
          >
            <span class="switch-desc">回放设置</span>
            <vh-switch v-model="isPlayBack" size="mini" class="playback-btn">
            </vh-switch>
            <span class="switch-desc">{{ playBackDesc }}</span>
          </div>
          <div class="vhall-question-playback playback-set">
            <span class="switch-desc">强制填写</span>
            <vh-switch
              v-model="mandatory_filling"
              :active-value="1"
              :inactive-value="0"
              size="mini"
              class="playback-btn"
            >
            </vh-switch>
            <span class="switch-desc"
              >{{
                mandatory_filling == 1 ? "已开启" : "开启后"
              }}，观众未提交问卷成功时，将无法关闭问卷页面</span
            >
          </div>
          <!-- <ve-upload title="上传头图，推荐尺寸为800x180px，大小不超过2M"
                               accept="png|jpg|jpeg|bmp"
          :fileSize="2048"></ve-upload> -->
        </div>
        <div class="question-info" v-if="q" v-show="q.detail.length > 0">
          <draggable
            ref="drag"
            @update="moved"
            v-model="q.detail"
            :options="{ handle: '.sort', animation: 200 }"
            @start="drag = true"
            @end="drag = false"
          >
            <transition-group
              type="transition"
              :name="!drag ? 'flip-list' : null"
            >
              <!--<com-question @click="showEdit"-->
              <com-question
                @remove="remove"
                @copy="copy"
                v-for="(item, index) in q.detail"
                :detail="q.detail"
                :value.sync="item"
                :index="index"
                :key="index"
              ></com-question>
            </transition-group>
          </draggable>
        </div>
        <!-- 提示错误 -->
        <div class="no-question" v-show="q && q.detail && q.detail.length < 1">
          <span>
            <img
              src="data:image/png;base64,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"
              class="no-create"
              alt=""
          /></span>
          <p>{{ addTitle }}</p>
          <!-- <span style="color: #fc5659" v-show="q.detail.length<1">&nbsp;&nbsp;{{tipMsg}}</span> -->
        </div>
        <!-- 隐私协议 -->
        <div class="vhall-question-playback privacy_top">
          <span class="switch_lineh"> 隐私协议 </span>
          <div class="privacy_box">
            <vh-radio-group v-model="privacyRadio">
              <vh-radio :label="1">展示系统自带协议</vh-radio>
              <div class="privacy_tip">
                预览效果：提交即同意<span @click="openUrl(PRIVACY_POLICY)"
                  >《隐私政策》</span
                >
                及
                <span @click="openUrl(PRIVACY_UPO)">《用户保护协议》</span>
              </div>
              <vh-radio :label="2" class="cus-protocol">自定义协议</vh-radio>
              <span class="set" @click="toggolSetPravacy">去设置</span>
              <div class="privacy_tip">
                预览效果：我们根据<span class="no_pointer">《隐私声明》</span
                >保护您所填写的所有信息
              </div>
            </vh-radio-group>
          </div>
        </div>
        <qPrivacy
          v-if="showPrivacyDialog"
          :showPrivacyDialog="showPrivacyDialog"
          :privacyDate="privacyDate"
          @toggolSetPravacy="toggolSetPravacy"
          @savePrivacy="savePrivacy"
        >
        </qPrivacy>
        <!-- 功能区 end -->
        <div class="question-bottom">
          <button
            @click="doSave"
            :disabled="q && q.detail && q.detail.length < 1"
          >
            保存
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Questionnaire from "src/model/questionnaire";
import draggable from "vuedraggable";
import question from "../components/questionnaire/wrap.vue";
// import messageBox from '../components/message-box.vue'
import ComInput from "../components/input/com.vue";
import { types as QTypes } from "../components/questionnaire/types";
import CONST from "src/model/const";
import { v1 as uuidV1 } from "uuid";
// import VeUpload from 'src/components/ve-upload-image'
import qPrivacy from "../components/q-privacy.vue";
import { PRIVACY_POLICY, PRIVACY_UPO } from "src/utils/conf";
export default {
  components: {
    comQuestion: question,
    draggable,
    "com-input": ComInput,
    qPrivacy,
    // messageBox
  },
  provide() {
    return {
      sdk: this.sdk,
      defaultPhone: "",
      isPreview: false,
      isH5: false,
      id: this.id,
      i18nLocal: this.i18nLocal,
    };
  },
  props: {
    id: [String, Number],
    sdk: Object,
    notify: Boolean,
    saasBaseUrl: String,
    isPlayBackSet: Boolean,
    addTitle: {
      type: String,
      default: "点击左侧内容创建问卷",
    },
    i18nLocal: String,
  },
  data() {
    return {
      tipMsg: "",
      currentIndex: 1,
      drag: false,
      domainUrl: "",
      isPlayBack: true,
      mandatory_filling: 0,
      privacyRadio: 1,
      defaultImg: require("./signup-form/form-head-new1.png"),
      mainContentFixed: false,
      menuBarFixed: "",
      titleCheck: {
        value: {
          ext: {
            edit: false,
          },
        },
        validate: () => {
          // if (this.titleError || !this.q.title.trim()) {
          //   this.titleError = true
          //   this.q.title = '请设置问卷标题'
          //   return false
          // }
          return true;
        },
      },
      descriptionCheck: {
        value: {
          ext: {
            edit: false,
          },
        },
        validate: () => {
          return true;
        },
      },
      titleError: false,
      currentEdit: null,
      q: null,
      isAddQue: false,
      isSaving: false,
      isFlag: true,
      token: window.localStorage.getItem("token"),
      params: {
        path: "sys/img_url",
        type: "image",
        interact_token: window.sessionStorage.getItem("interact_token") || "",
      },
      showPrivacyDialog: false,
      privacyDate: {
        privacyConten: "我们根据《隐私声明》保护您填写的所有信息",
        details: [{ name: "《隐私声明》", url: "" }],
      }, // 协议详情
      enable_banner: true,
      PRIVACY_POLICY,
      PRIVACY_UPO,
    };
  },
  computed: {
    playBackDesc() {
      if (this.isPlayBack) {
        return "已开启，观看回放时可以填写问卷";
      } else {
        return "开启后，观看回放时可以填写问卷";
      }
    },
    headersVo() {
      // let token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE2MjEyMTc2MzQsImV4cCI6MTYyMzgwOTYzNCwidXNlcl9pZCI6MTY0MjI3NzAsInBsYXRmb3JtIjoiMTcifQ.oM7dHKK7-mAzrPvrDVWBGXZcVnix8OqFYiNljspuzXs'
      let vo = { token: this.token, platform: 17, "request-id": uuidV1() };
      // 取缓存userId相关
      if (window.sessionStorage.getItem("userId")) {
        vo["gray-id"] = window.sessionStorage.getItem("userId");
      }
      return vo;
    },
    isRadio() {
      return (
        this.q &&
        this.q.detail.filter((item) => {
          return item.type === "radio" && item.style === "radio";
        }).length >= 20
      );
    },
    isSelect() {
      return (
        this.q &&
        this.q.detail.filter((item) => {
          return item.type === "select" && item.style === "select";
        }).length >= 20
      );
    },
    isCheckbox() {
      return (
        this.q &&
        this.q.detail.filter((item) => {
          return item.type === "checkbox";
        }).length >= 20
      );
    },
    isQue() {
      return (
        this.q &&
        this.q.detail.filter((item) => {
          return item.type === "text" && item.style === "text";
        }).length >= 20
      );
    },
    isArea() {
      return (
        this.q &&
        this.q.detail.filter((item) => {
          return item.type === "area";
        }).length >= 1
      );
    },
    isRemark() {
      return (
        this.q &&
        this.q.detail.filter((item) => {
          return item.type === "remark";
        }).length >= 5
      );
    },
    isCompany() {
      return (
        this.q &&
        this.q.detail.filter((item) => {
          return item.style === "company";
        }).length >= 1
      );
    },
    isPosition() {
      return (
        this.q &&
        this.q.detail.filter((item) => {
          return item.style === "position";
        }).length >= 1
      );
    },
    isName() {
      return (
        this.q &&
        this.q.detail.filter((item) => {
          return item.style === "name";
        }).length >= 1
      );
    },
    isSex() {
      return (
        this.q &&
        this.q.detail.filter((item) => {
          return item.style === "sex";
        }).length >= 1
      );
    },
    isPhone() {
      return (
        this.q &&
        this.q.detail.filter((item) => {
          return item.style === "phone";
        }).length >= 1
      );
    },
    isEmail() {
      return (
        this.q &&
        this.q.detail.filter((item) => {
          return item.style === "email";
        }).length >= 1
      );
    },
    isAreade() {
      return (
        this.q &&
        this.q.detail.filter((item) => {
          return item.style === "areade";
        }).length >= 1
      );
    },
    isBirthday() {
      return (
        this.q &&
        this.q.detail.filter((item) => {
          return item.style === "birthday";
        }).length >= 1
      );
    },
    isIndustry() {
      return (
        this.q &&
        this.q.detail.filter((item) => {
          return item.style === "industry";
        }).length >= 1
      );
    },
    isEducation() {
      return (
        this.q &&
        this.q.detail.filter((item) => {
          return item.style === "education";
        }).length >= 1
      );
    },
  },
  created() {
    if (this.id) {
      var newArr = [];
      this.sdk.getById(this.id).then((res) => {
        res.data.detail.forEach((item, i) => {
          // delete item.ext
          if (!item.ext) {
            item.ext = {};
          } else {
            item.ext = JSON.parse(item.ext);
          }
          // 接口ext返回采用说引号包裹双引号 不能正常解析
          // if (!item.ext) {
          //   item.ext = {};
          // } else if (typeof item.ext == 'string'){
          //   let obj = item.ext
          //   item.ext = {}

          //   let timeStart = obj.indexOf('time')
          //   let end = obj.indexOf('}')
          //   let bool = obj.indexOf('true')
          //   if (bool > -1) {
          //     item.ext.edit = true
          //   } else {
          //     item.ext.edit = false
          //   }
          //   if (timeStart > -1) {
          //     item.ext.time = obj.substring(timeStart + 6, end)
          //   }
          // }
          item.ext.edit = true;
          console.log(item.ext, ">>>>>>>>>>>>");
          // item.ext = JSON.stringify(item.ext)
          // Object.assign(item.ext, {edit: true})
        });
        this.q = new Questionnaire(res.data);
        this.LcoalOriginalDetail = JSON.parse(JSON.stringify(res.data.detail));
        this.domainUrl = res.data.imgUrl;
        let extension = JSON.parse(res.data.extension);
        console.log(typeof extension, "1232143243546457568");
        if (extension) {
          // 隐私协议新增参数
          this.privacyRadio = extension.privacyRadio || 1;
          this.privacyDate = extension;
          if (extension.enable_banner === undefined) {
            this.enable_banner = true; // 历史数据没有头图开关字段为true
          } else {
            this.enable_banner = Boolean(extension.enable_banner); // 设置头图开关回显
          }
          this.isPlayBack = Boolean(extension.playback_filling);
          this.mandatory_filling = extension.mandatory_filling
            ? Number(extension.mandatory_filling)
            : 0; //强制填写开关
        }
        console.log(55675675656, this.q);
        if (this.q.description === null) {
          this.q.description = "";
        }
        if (this.q.title === null) {
          this.q.title = "";
        }
        console.log("问卷编辑");
        console.log(this.q);
      });
    } else {
      this.q = new Questionnaire({ detail: [] });
    }
  },

  mounted() {
    // document.addEventListener('click', () => {
    //     this.hideEdit()
    // })
    console.log(this.q);
    console.log(this.sdk);
    if (document.querySelector(".question-box-page")) {
      this.$nextTick(() => {
        document.addEventListener("scroll", this.handleScroll);
      });
    }
  },
  destroyed() {
    document.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    clickSelect() {
      // 点击选项
      // if (this.isName) {
      //   return;
      // }
      this.$nextTick(() => {
        let wrapList =
          document.getElementsByClassName("question-wrap")[
            this.q.detail.length - 1
          ];
        const dom = document.querySelector(
          ".questionnaire-dialog .vh-dialog__body"
        );
        dom && dom.scrollTo(0, wrapList.offsetTop - 60);
      });
      // }
    },
    deletes() {
      this.domainUrl = "";
    },
    getScrollTop() {
      var scrollPos;
      if (window.pageYOffset) {
        scrollPos = window.pageYOffset;
      } else if (document.compatMode && document.compatMode != "BackCompat") {
        scrollPos = document.documentElement.scrollTop;
      } else if (document.body) {
        scrollPos = document.body.scrollTop;
      }
      return scrollPos;
    },
    handleScroll() {
      const addQue = document.querySelector(".add-que");
      if (addQue) {
        let scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
        if (scrollTop > 60) {
          addQue.classList.add("scrollPosition");
        } else {
          addQue.classList.remove("scrollPosition");
        }
      } else {
        document.removeEventListener("scroll", this.handleScroll);
      }
    },
    fixExamControllBar() {
      let scrTop = document.querySelector(".btn-box");
      console.log(this.getScrollTop());
      if (this.getScrollTop() > 80) {
        scrTop.classList.add("is-fixed");
        document.querySelector(".edit-content-main").style["margin-left"] =
          153 + "px";
      } else {
        scrTop.classList.remove("is-fixed");
        document.querySelector(".edit-content-main").style["margin-left"] =
          0 + "px";
      }
    },
    doSave() {
      if (!this.isFlag) {
        return;
      }
      if (this.q.detail.length <= 0) {
        this.tipMsg = "请添加题目";
        this.isSaving = false;
        return;
      } else {
        this.tipMsg = "";
      }
      this.isSaving = true;
      this.isFlag = false;
      setTimeout(() => {
        this.isFlag = true;
      }, 3000);
      if (!this.q.title) {
        this.q.title = "";
      }
      if (!this.q.description) {
        this.q.description = "";
      }
      console.log(this.notify);
      console.log(this.currentEdit);
      setTimeout(() => {
        if (this.currentEdit) return;
        if (this.sdk.validate(this.q).state) {
          const ary = [];
          let _data = JSON.parse(JSON.stringify(this.q));

          if (_data.id) {
            // 是否是编辑问卷，如果是则判断题目是否修改过
            _data.detail.forEach((topic) => {
              let clok = true;
              this.LcoalOriginalDetail.forEach((originTopic) => {
                if (
                  topic.id === originTopic.id &&
                  JSON.stringify(originTopic) === JSON.stringify(topic)
                ) {
                  clok = false;
                  ary.push({
                    id: topic.id,
                    is_quote: 1,
                  });
                }
              });
              clok && ary.push(topic);
            });
            _data.detail = ary;
          }
          if (this.domainUrl) {
            _data.imgUrl = this.domainUrl;
          } else {
            _data.imgUrl = "";
          }
          _data.extension = {
            // 隐私协议新增参数
            ...this.privacyDate,
            privacyRadio: this.privacyRadio,
            enable_banner: Number(this.enable_banner),
            playback_filling: Number(this.isPlayBack),
            mandatory_filling: this.mandatory_filling,
          };
          _data.extension = JSON.stringify(_data.extension);
          console.log(ary, 987654321);
          this.sdk
            .save(_data)
            .then((res) => {
              if (res.code === 200) {
                let data = _data;
                if (this.q.id) {
                  this.$emit(CONST.EVENT.UPDATE, data);
                } else {
                  data.id = res.data;
                  this.$emit(CONST.EVENT.CREATE, data);
                }
                // if (this.notify) {
                //     this.$notify({
                //         message: '保存成功',
                //         type: 'success'
                //     });
                // }
              } else {
                this.$emit(CONST.EVENT.ERROR, res);
                // if (this.notify) {
                //     this.$notify.error({
                //         message: '保存失败'
                //     });
                // }
              }
              this.isSaving = true;
            })
            .catch((error) => {
              this.isSaving = true;
              this.$emit(CONST.EVENT.ERROR, error);
              if (this.notify) {
                // this.$notify.error({
                //     message: '服务器端错误'
                // });
              }
            });
        }
      }, 0);
    },
    copy(data) {
      if (this.currentEdit) {
        if (this.currentEdit.validate()) {
          let { index, value } = data;
          value = JSON.parse(JSON.stringify(value));
          value.ext.edit = false;
          this.q.detail.splice(index + 1, 0, value);
        }
      }
    },
    handleAvatarSuccess(res, file) {
      if (res.code === 200) {
        if (res.data.domain_url) {
          // 文件上传成功，保存信息
          this.domainUrl = res.data.domain_url;
        }
      }
    },
    uploadProcess(event, file, fileList) {
      console.log("uploadProcess", event, file, fileList);
    },
    uploadError(err, file, fileList) {
      console.log("uploadError", err, file, fileList);
      this.$message({
        message: `上传表单头图失败`,
        showClose: true,
        // duration: 0,
        type: "error",
        customClass: "zdy-info-box",
      });
    },
    uploadPreview(file) {
      console.log("uploadPreview", file);
    },
    beforeAvatarUpload(file) {
      console.log(file);
      const typeList = ["png", "jpeg", "gif", "bmp"];
      console.log(file.type.toLowerCase());
      let typeArr = file.type.toLowerCase().split("/");
      const isType = typeList.includes(typeArr[typeArr.length - 1]);
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isType) {
        this.$message({
          message: `上传表单头图只能是 ${typeList.join("、")} 格式`,
          showClose: true,
          // duration: 0,
          type: "error",
          customClass: "zdy-info-box",
        });
        return false;
      }
      if (!isLt2M) {
        this.$message({
          message: `上传问卷头图大小不能超过 2M`,
          showClose: true,
          // duration: 0,
          type: "error",
          customClass: "zdy-info-box",
        });
        return false;
      }
      return isType && isLt2M;
    },
    remove(index) {
      this.currentEdit = null;
      this.q.detail.splice(index, 1);
    },
    titleFocus() {
      if (this.titleError) {
        this.titleError = false;
        this.q.title = "";
      }
    },
    changeTitle(e) {
      if (!this.q.title) {
        this.q.title = e;
      }
    },
    changeDesc(e) {
      if (!this.q.description) {
        this.q.description = e;
      }
    },
    moved(e) {
      console.log(this.q.detail);
      this.currentEdit = this.$refs.drag.$children[e.newIndex + 1]; // ？？？
    },
    showEdit(target) {
      if (this.currentEdit === target) {
        return;
      }
      if (this.currentEdit) {
        if (this.currentEdit.validate()) {
          this.currentEdit.value.ext.edit = false;
          this.currentEdit = target;
          target.value.ext.edit = true;
        }
      } else {
        this.currentEdit = target;
        target.value.ext.edit = true;
      }
    },
    hideEdit() {
      if (this.currentEdit) {
        if (this.currentEdit.validate()) {
          this.currentEdit.value.ext.edit = false;
          this.currentEdit = null;
        }
      }
    },
    messagesClose() {
      this.isAddQue = false;
    },
    // open隐私协议弹框
    toggolSetPravacy() {
      this.showPrivacyDialog = !this.showPrivacyDialog;
    },
    // 保存协议数据
    savePrivacy(data) {
      this.privacyDate = data;
      console.log(data, "savePrivacy");
    },
    // 跳转链接
    openUrl(val) {
      window.open(val);
    },
  },
};
</script>

<style scoped lang="scss">
.iconfont-v3 {
  font-family: "iconfont-v3";
  vertical-align: bottom;
}
::-webkit-scrollbar {
  width: 0;
  height: 0;
  color: transparent;
}
.question-edit-wrap {
  margin: 0 auto;
  height: 100%;
  color: #666;
  position: relative;
  overflow: hidden;
  .banner {
    font-size: 14px;
    color: #595959;
    display: flex;
    align-items: center;
    .banner-switch {
      margin: 0 10px 0 10px;
    }
  }
  .btn-box {
    margin-bottom: 35px;
    width: 145px;
    padding-bottom: 24px;
    float: left;
    height: 480px;
    position: fixed;
    overflow-y: scroll;
    .content {
      width: 100%;
      height: 100%;
      .title {
        font-size: 16px;
        height: 36px;
        text-align: left;
        // padding-left: 30px;
        line-height: 36px;
        color: #666;
        margin: 0;
      }
      .funActions {
        width: 100%;
        a {
          display: inline-block;
          width: 145px;
          height: 36px;
          margin-right: 8px;
          line-height: 36px;
          border: 1px solid transparent;
          font-size: 14px;
          text-align: left;
          text-decoration: none;
          color: #1a1a1a;
          img {
            width: 14px;
            height: 14px;
            vertical-align: middle;
          }
          &:hover {
            color: #fb3a32;
          }
          &:active {
            color: #b3b3b3;
          }
          &.disabled {
            color: #b3b3b3;
            cursor: default;
          }
        }
      }
    }
    .goback-btn {
      display: inline-block;
      position: absolute;
      top: 0;
      right: 0;
      text-decoration: none;
      text-align: center;
      float: right;
    }
    .add-que {
      position: relative;
      height: 100%;
    }
  }

  .question-content {
    padding: 0 20px 20px 20px;
  }

  ::v-deep {
    .com-input {
      margin-right: 8px;

      &.error {
        input {
          border-color: #fc5659;
          color: #fc5659;
        }

        .limit {
          display: none;
        }
      }
    }

    * {
      box-sizing: border-box;
    }

    ul {
      list-style: none;
      margin: 0;
      padding: 0;
    }

    .edit-content {
      height: 100%;
      width: 100%;
      overflow: hidden;
      font-size: 14px;
      display: flex;

      .edit-content-left {
        height: 100%;
        width: 240px;
        padding: 0 30px;
        position: absolute;
        left: 0;
        // background-color: white;
        border: 1px solid #dadada;

        .fixed-info {
          margin-top: 30px;
        }

        .custom-info {
          margin-top: 50px;
        }

        ul {
          margin-top: 10px;
          overflow: hidden;
        }

        li {
          width: 70px;
          height: 30px;
          line-height: 30px;
          margin-right: 32px;
          margin-bottom: 15px;
          float: left;
          font-size: 12px;
          text-align: center;
          border-radius: 4px;
          border: 1px solid #dadada;
          cursor: pointer;

          &:nth-child(2n) {
            margin-right: 0;
          }
        }
      }

      .edit-content-main {
        position: relative;
        height: 100%;
        float: right;
        width: calc(100% - 145px);
        margin-left: 145px;
        .base-info {
          margin-bottom: 25px;
          .com-input {
            height: 40px;
            input,
            textarea {
              font-size: 14px;
            }
          }

          .q-title {
            margin-bottom: 16px;
            width: 100%;
            // height: 100px;
            // border: 1px solid #d2d2d2;
            background-color: #fff;
            padding: 24px;
            border-radius: 4px;

            .show-des {
              font-size: 16px;
              color: #1a1a1a;
              margin-bottom: 10px;
            }
            .question_title {
              .limit {
                top: 50%;
                right: 12px;
              }
              input {
                color: #1a1a1a;
              }
            }
          }

          .q-des {
            width: 100%;
            padding: 24px;
            background: #fff;
            text-align: left;
            border-radius: 4px;
            height: 100%;
            // TODO:优化可兼容的多行文本超出隐藏
            .show-des {
              font-size: 16px;
              color: #1a1a1a;
              margin-bottom: 10px;
              overflow: hidden;
              .limit {
                right: 10px;
              }
            }

            .editing {
              margin-bottom: -25px;
            }

            .com-input {
              height: 97px;
              width: 100%;
            }

            .limit {
              bottom: 4px;
              right: 55px;
            }
            textarea {
              color: #1a1a1a;
            }
          }
        }

        .question-info {
          width: 100%;
        }
        .no-question {
          width: 100%;
          text-align: center;
          span {
            display: inline-block;
            width: 130px;
            width: 130px;
          }
          img {
            width: 100%;
            height: 100%;
            object-fit: scale-down;
          }
          p {
            color: #8c8c8c;
            font-size: 16px;
          }
        }

        .question-bottom {
          width: 100%;
          text-align: left;
          margin-top: 40px;
          button {
            width: 160px;
            height: 40px;
            border: none;
            border-radius: 20px;
            background-color: #fb3a32;
            color: #fff;
            font-size: 14px;
            line-height: 40px;
            outline: none;
            cursor: pointer;
            &:hover {
              background-color: #ff7b78;
              border: none;
            }
            &:disabled {
              background-color: #f09d99;
            }
          }
        }
      }
      .content-fixed {
        margin-left: 145px;
      }
    }

    .modal-body {
      padding-top: 0;
    }
    .q-edit-content {
      position: relative;
    }
    .vhall-question-content-img {
      font-size: 16px;
      color: #1a1a1a;
      background: #fff;
      margin: 16px 0;
      padding: 24px;
      border-radius: 4px;
      .show-des {
        padding-bottom: 10px;
      }
      .avatar-uploader {
        width: 100%;
        height: 80px;
        border-radius: 4px;
      }
      .vh-upload {
        width: 100%;
      }

      .img-logo {
        margin: 0 auto;
        height: 80px;
        width: 100%;
        img {
          height: 100%;
          object-fit: scale-down;
          width: 100%;
          margin: 0px auto;
        }
      }
      .box {
        width: 100%;
        height: 100%;
        display: table;
        > div {
          width: 100%;
          height: 100%;
          position: relative;
          // padding-top: 30px;
          display: table-cell;
          vertical-align: middle;
          text-align: center;
          &:hover {
            .mask {
              display: flex;
              justify-content: center;
              align-items: center;
              color: #fff;
              line-height: 20px;
              // padding: 0 10px;
            }
            .bottom-mask {
              display: flex;
              justify-content: space-around;
              align-items: center;
              color: #fff;
            }
          }
        }
      }

      .mask {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.7);
        display: none;
        span {
          font-size: 14px;
          &:nth-child(2) {
            margin: 0 0 0 10px;
            i {
              line-height: 1;
            }
          }
          i {
            color: #fff;
            font-size: 18px;
            vertical-align: middle;
          }
        }
      }
      .tips {
        font-size: 14px;
        color: #999;
        text-align: left;
        padding-top: 10px;
      }
    }
    .vhall-question-playback {
      &.playback-set {
        font-size: 14px;
        color: #595959;
        .chose {
          margin-left: 5px;
        }
      }
      font-size: 16px;
      color: #1a1a1a;
      background: #fff;
      padding: 20px;
      border-radius: 4px;
      &.playback-set {
        display: flex;
        align-items: center;
        .switch-desc {
          color: #595959;
          font-size: 14px;
        }
        .playback-btn {
          margin: 0 10px 0 10px;
        }
      }
      .switch_lineh {
        line-height: 40px;
        flex-shrink: 0;
      }
      .privacy_box {
        .cus-protocol {
          margin-right: 0;
        }
        .vh-radio-group {
          margin-left: 10px;
        }
        .vh-radio {
          // margin-top: 5px;
          line-height: 40px;
        }
        .set {
          padding-left: 8px;
          font-size: 14px;
          color: #3562fa;
          cursor: pointer;
        }
        .privacy_tip {
          font-size: 14px;
          color: #666;
          background: rgba(226, 226, 226, 0.4);
          // margin-left: 25px;
          // margin-top: 5px;
          width: 580px;
          line-height: 40px;
          padding-left: 10px;
          border-radius: 4px;
          span {
            cursor: pointer;
            color: #3562fa;
          }
          .no_pointer {
            cursor: default;
          }
        }
      }
    }
    .privacy_top {
      display: flex;
      margin-top: 16px;
    }
  }
}
</style>

<style lang="scss">
@import "../assets/css/edit_questionnaire.scss";
.vhall-question-content {
  width: 100%;
  height: 100%;
  &-baseInfo {
    &__title {
      &__label {
        font-size: 12px;
        color: rgb(102, 102, 102);
      }
    }
  }

  input {
    border: 1px solid rgb(210, 210, 210);
  }

  &-desc {
    text-align: center;

    text-area {
      line-height: 2;
    }
  }
  .funActions .button-list .btn-li {
    width: 100%;
  }

  .funActions .button-list .btn-li .disable {
    background-color: #f8f8f8;
    border-color: #e4e4e4;
    color: #d7d7d7;
  }

  .funActions .button-list .btn-li .disable:hover {
    border-color: #e4e4e4;
  }
  .funActions .button-list .btn-li {
    display: flex;
    flex-direction: row-reverse;
  }
  .funActions .button-list .btn-li a {
    display: inline-block;
    width: 170px;
    height: 36px;
    margin-right: 8px;
    // margin-bottom: 10px;
    line-height: 36px;
    // border: 1px solid #fc5659;
    // border-radius: 4px;
    // background-colorgb(3, 3, 3)fff;
    text-align: left;
    text-decoration: none;
    color: #1a1a1a;
    padding-left: 15px;
    &:nth-child(4n) {
      margin-right: 0;
    }
    &:link {
      font-size: 12px;
      color: #fc5659;
    }
    &:hover {
      border-color: #fc5659;
      background-color: #fc5659;
      color: #fff;
    }
    &.disabled {
      border-color: #d2d2d2;
      background-color: #fff;
      color: #d2d2d2;
      cursor: default;
    }
    img {
      margin-top: -2px;
    }
  }
}
.questionnaire-lve {
  .question-edit-wrap .vhall-question-playback .privacy_box .privacy_tip {
    width: 415px !important;
  }
}
.question-edit-wrap .question-wrap .com-input.otherItem {
  padding-left: 24px;
  padding-right: 35px;
  .limit {
    right: 43px;
  }
}
</style>
